import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["invited.accountAction"],
  action => action
);
